export default "__VITE_ASSET__BwTSRnPd__"